'use strict';

(function($, Drupal) {

  function sdgItemsSlider() {
    const sdgItemsSliderWrapper = $('.js-view-sdg-items-slider-content:not(.slick-slider)');
    let initialSlide = 0;

    if ($('body').attr('data-sdgnumber')) {
      initialSlide = Number($('body').attr('data-sdgnumber')) - 1;
    }

    if (sdgItemsSliderWrapper.length > 0) {
      const slider = sdgItemsSliderWrapper.slick({
        arrows: true,
        autoplay: false,
        centerMode: true,
        centerPadding: '24px',
        dots: false,
        infinite: true,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        rows: 0,
        slidesToShow: 3,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              centerPadding: '40px'
            }
          },
          {
            breakpoint: 1279,
            settings: {
              slidesToShow: 5
            }
          }
        ]
      })

      slider.slick('slickGoTo', initialSlide, true);
      if ($('html').attr('dir') === 'rtl') {
        slider.slick('slickSetOption', 'rtl', true);
      }
    }
  }

  Drupal.behaviors.viewSdgItemsSlider = {
    attach: () => {
      sdgItemsSlider();
    }
  }
}(jQuery, Drupal))
